import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import {
  CrewExperienceValue,
  RoleExperienceValue,
} from '@/components/Forms/QuestionType/CrewType';
import CrewExperienceType from '@/components/Forms/QuestionType/CrewExperienceType.vue';
import { QuestionAnswerState } from '@/vuex/AnswerStore';
import ErrorMessage from '@/components/Forms/QuestionType/ErrorMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrewExperience',
  props: {
  value: String,
  qa: { type: Object as PropType<QuestionAnswerState> },
},
  emits: {
  updateValue: (e: [value: string, valid: boolean]) => e && true,
},
  setup(__props, { emit }) {

const props = __props;





const jsonValue = computed<CrewExperienceValue>({
  get() {
    try {
      return JSON.parse(props.value);
    } catch (e) {
      return {};
    }
  },
  set(v) {
    emit('updateValue', [JSON.stringify(v), true]);
  },
});

const errMsg = computed(() => props.qa.valid.error);

const options: Array<{
  label: string;
  key: keyof CrewExperienceValue;
  ranks: string[];
  min: number;
}> = [
  {
    label: 'Master',
    key: 'master',
    ranks: ['Chief Officer', 'Master'],
    min: 24,
  },
  {
    label: 'Chief Officer',
    key: 'chiefOfficer',
    ranks: ['Second Officer', 'Chief Officer'],
    min: 24,
  },
  {
    label: 'Chief Engineer',
    key: 'chiefEngineer',
    ranks: ['Second Engineer', 'Chief Engineer'],
    min: 12,
  },
  {
    label: 'Second Engineer',
    key: 'secondEngineer',
    ranks: ['Third Engineer', 'Second Engineer'],
    min: 12,
  },
];

function update(key: keyof CrewExperienceValue, value: RoleExperienceValue) {
  jsonValue.value = { ...jsonValue.value, [key]: value };
}

return { __sfc: true,props, emit, jsonValue, errMsg, options, update, CrewExperienceType, ErrorMessage }
}

})